import { handleErrors } from "@/utils/handle-errors";
import fetch from "@mv/flow-shared-utils/functions/fetch";
import { SdkTableColumnNote } from "@/interfaces/sdk-dictionary";
export const saveNote = (note: SdkTableColumnNote) => ({ type: "saveNote", note });
export const updateNote = (note: SdkTableColumnNote) => ({ type: "updateNote", note });
export const deleteNote = (note: SdkTableColumnNote) => ({ type: "deleteNote", note });

export const actions = {
  saveNote(state: any, { note }: { note: SdkTableColumnNote }) {
    return fetch(`dictionary/api/note`, {
      method: "POST",
      body: JSON.stringify(note),
    })
      .then(handleErrors)
      .then((data) => data);
  },

  updateNote(state: any, { note }: { note: SdkTableColumnNote }) {
    return fetch(`dictionary/api/note`, {
      method: "PUT",
      body: JSON.stringify(note),
    })
      .then(handleErrors)
      .then((data) => data);
  },

  deleteNote(state: any, { note }: { note: SdkTableColumnNote }) {
    return fetch(`dictionary/api/note/${note.id}`, {
      method: "DELETE",
    }).then(handleErrors);
  },
};
